module.exports = __webpack_public_path__ + "img/xzmb.91c76229.svg";